import { BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS } from '@smoothie-framework/ui-styles/styling/contract';
import { buildFlexContainerNode, } from '../../authoring/flex-layout';
export function StackCol(props) {
    const { id, as, asChild, gap = defaultStackColProps.gap, align = defaultStackColProps.align, justify = defaultStackColProps.justify, wrap = defaultStackColProps.wrap, style, role, ariaLabel, ariaLabelledBy, 'aria-labelledby': ariaLabelledByAttribute, ariaDescribedBy, className, children, 'data-ui': dataUi, ...utilityPropsInput } = props;
    return buildFlexContainerNode({
        componentType: 'StackCol',
        baseClass: 'smth-stack-col',
        defaultDataUi: 'StackCol',
        defaultGap: defaultStackColProps.gap,
        defaultAlign: defaultStackColProps.align,
        defaultJustify: defaultStackColProps.justify,
        defaultWrap: defaultStackColProps.wrap,
        defaultDirection: 'column',
        gap,
        align,
        justify,
        wrap,
        emitDirectionProp: false,
        id,
        as,
        asChild,
        style,
        role,
        ariaLabel,
        ariaLabelledBy: ariaLabelledBy !== undefined ? ariaLabelledBy : ariaLabelledByAttribute,
        ariaDescribedBy,
        className,
        children,
        dataUi,
        utilityPropsInput,
    });
}
const stackColDefaultUtilityProps = BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS.StackCol;
export const defaultStackColProps = Object.freeze({
    gap: stackColDefaultUtilityProps.gap,
    align: stackColDefaultUtilityProps.align,
    justify: stackColDefaultUtilityProps.justify,
    wrap: stackColDefaultUtilityProps.wrap,
});
//# sourceMappingURL=StackCol.js.map